import type { OverviewReport, TicketResponseReport } from "../../../queries/reports";
import { MetricTile } from "./MetricTile";
import { formatDuration } from "./format";
import styles from "./dash.module.css";

interface Props {
  overview?: OverviewReport;
  response?: TicketResponseReport;
  rangeLabel: string;
}

export const KpiBand = ({ overview, response, rangeLabel }: Props) => {
  const num = (n: number | undefined) => (n === undefined ? "—" : n);
  const breaches = response?.summary ? response.summary.firstResponseBreaches + response.summary.resolutionBreaches : undefined;
  const overdue = overview?.tasks.overdue;
  return (
    <section className={styles.kpis} aria-label="Key figures">
      <MetricTile label="Open tickets" value={num(overview?.tickets.open)} note="not yet solved" />
      <MetricTile
        label="Unanswered"
        value={num(overview?.tickets.unanswered)}
        note="no first response"
        tone={overview && overview.tickets.unanswered > 0 ? "warn" : "default"}
      />
      <MetricTile
        label="SLA breaches"
        value={num(breaches)}
        note={response?.summary ? `${response.summary.firstResponseBreaches} response, ${response.summary.resolutionBreaches} resolution` : rangeLabel}
        tone={breaches ? "danger" : "default"}
      />
      <MetricTile label="Avg first response" value={formatDuration(response?.summary.avgFirstResponseMinutes)} note={rangeLabel} />
      <MetricTile label="Avg resolution" value={formatDuration(response?.summary.avgResolutionMinutes)} note={rangeLabel} />
      <MetricTile
        label="Overdue tasks"
        value={num(overdue)}
        note={overdue ? "past their due date" : "nothing late"}
        tone={overdue ? "danger" : "ok"}
      />
    </section>
  );
};
